import React, { Component } from 'react';
import '../../Common/shared.css'
import '../style.css';

import T from 'i18n-react';
import TaxYearForm from '../taxYearForm'
import InterviewTitleProgress from '../../Common/interviewTitleProgress'

class InterviewPage9 extends Component {
    constructor(props) {
        super(props);

        var taxYearInfo = this.props.taxYearInfo || {
            employedChecked: false,
            selfEmployedChecked: false,
            retiredChecked: false,
            businessOwnerChecked: false,
            workExpensesChecked: false,
            disabilityChecked: false,
            medicalExpensesChecked: false,
            benefitsEIChecked: false,
            investmentIncomeChecked: false,
            rRSPChecked: false,
            rentalChecked: false,
            foreignIncomeChecked: false,
            dependentsChecked: false,
            propertySaleChecked: false,
            spouseSupportChecked: false,
            movingExpensesChecked: false,
            tuitionChecked: false,
            donationsChecked: false,
            fireRescueChecked: false,
            farmingChecked: false
        }

        this.state = {
            taxYearInfo,
            layoutType: this.props.layoutType,
            lang: this.props.lang
        }
    }

    componentWillReceiveProps(newProps) {
        if (this.state.layoutType !== newProps.layoutType) {
            this.setState({ layoutType: newProps.layoutType })
        }
        if (this.state.lang !== newProps.lang) {
            this.setState({ lang: newProps.lang })
        }
    }

    onTaxYearInfoChanged(taxYearInfo) {
        var newTaxYearInfo = {
            employedChecked: taxYearInfo.employedChecked,
            selfEmployedChecked: taxYearInfo.selfEmployedChecked,
            retiredChecked: taxYearInfo.retiredChecked,
            businessOwnerChecked: taxYearInfo.businessOwnerChecked,
            workExpensesChecked: taxYearInfo.workExpensesChecked,
            disabilityChecked: taxYearInfo.disabilityChecked,
            medicalExpensesChecked: taxYearInfo.medicalExpensesChecked,
            benefitsEIChecked: taxYearInfo.benefitsEIChecked,
            investmentIncomeChecked: taxYearInfo.investmentIncomeChecked,
            rRSPChecked: taxYearInfo.rRSPChecked,
            rentalChecked: taxYearInfo.rentalChecked,
            foreignIncomeChecked: taxYearInfo.foreignIncomeChecked,
            dependentsChecked: taxYearInfo.dependentsChecked,
            propertySaleChecked: taxYearInfo.propertySaleChecked,
            spouseSupportChecked: taxYearInfo.spouseSupportChecked,
            movingExpensesChecked: taxYearInfo.movingExpensesChecked,
            tuitionChecked: taxYearInfo.tuitionChecked,
            donationsChecked: taxYearInfo.donationsChecked,
            fireRescueChecked: taxYearInfo.fireRescueChecked,
            farmingChecked: taxYearInfo.farmingChecked
        }
        this.setState({ taxYearInfo: newTaxYearInfo });
        if (this.props.onTaxYearInfoChanged) {
            this.props.onTaxYearInfoChanged(newTaxYearInfo);
        }
    }

    render() {
        let titleNextContent;
        if (this.props.spouseTaxes === 'Y') {
            titleNextContent = 'Interview.Page9.nextTitle1';
        } else {
            titleNextContent = 'Interview.Page9.nextTitle2';
        }

        var percentage = '72'
        if ((this.props.maritalStatus === 'S') && (this.props.dependants === 'Y')) { percentage = '78' }
        if (this.props.maritalStatus !== 'S' && this.props.spouseTaxes === 'N' && this.props.dependants === 'Y') { percentage = '80' }
        if (this.props.maritalStatus !== 'S' && this.props.spouseTaxes === 'Y' && this.props.dependants === 'Y') { percentage = '82' }
        if (this.props.maritalStatus !== 'S' && this.props.spouseTaxes === 'Y' && this.props.dependants === 'N') { percentage = '78' }
        if (this.props.maritalStatus !== 'S' && this.props.spouseTaxes === 'N' && this.props.dependants === 'N') { percentage = '78' }

        return (
            <div>
                <div>
                    <div>
                        <InterviewTitleProgress taxYear={this.props.taxYear} percentage={percentage} title="Interview.Page9.headerTitle" nextTitle={titleNextContent} firstName={this.props.firstName} />
                    </div>
                    <div className="interview-page9-top-margin">
                        <T.text tag='p' text="Interview.Page9.headerContent0" className="headerText" />
                    </div>
                </div>

                <TaxYearForm
                    taxYear={this.props.taxYear}
                    taxYearInfo={this.state.taxYearInfo}
                    labelKey={'Interview.Page9'}
                    isReturningClient={this.props.isReturningClient}
                    onTaxYearInfoChanged={(taxYearInfo) => this.onTaxYearInfoChanged(taxYearInfo)}
                    layoutType={this.state.layoutType}
                    sectionHeader1={"Interview.Page9&10Common.ScenarioHeader1"}
                    sectionHeader2={"Interview.Page9&10Common.ScenarioHeader2"}
                    sectionHeader3={"Interview.Page9&10Common.ScenarioHeader3"}
                    sectionHeader4={"Interview.Page9&10Common.ScenarioHeader4"}
                    sectionHeader5={"Interview.Page9&10Common.ScenarioHeader5"}
                />
            </div>
        );
    }
}

export default InterviewPage9;